/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, July 7th 2022, 12:59:28 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PaymentIcon from "@mui/icons-material/Payment";
import RedoIcon from "@mui/icons-material/Redo";
import PublishIcon from "@mui/icons-material/Publish";
import { PenTool } from "react-feather";
import ArchiveIcon from "@mui/icons-material/Archive";
import DoneIcon from "@mui/icons-material/Done";
import { STAGE_TYPES } from "lib/schemas";
import { COLORSCHEME } from "theme/styles";
import ArticleIcon from "@mui/icons-material/Article";

export const StageIcons: { [k in keyof typeof STAGE_TYPES]: React.ReactNode } = {
  start: <PlayArrowIcon color="secondary" />,
  billing: <ReceiptIcon color="secondary" />,
  payment: <PaymentIcon color="secondary" />,
  submission: <PublishIcon color="secondary" />,
  resubmission: <RedoIcon color="secondary" />,
  signing: <PenTool color={COLORSCHEME.secondary} />,
  archive: <ArchiveIcon color="secondary" />,
  certificate_review: <ArticleIcon color="secondary" />,
  default: <WorkspacesIcon color="secondary" />,
  end: <DoneIcon color="secondary" />,
};
